import React, { useEffect, useState } from "react";
import SearchInput from "../../../../../../global components/Forms/SearchInput/SearchInput";
import s from "./Filters.module.scss";
import Paginate from "../../../../../../global components/Paginate/Pagination";
import ReusablePopover from "../../../../../../global components/Popover/ReuseablePopover";
import FiltersPopOverContent from "../FiltersPopOverContent";
import { FilterIcon } from "../../../../../../global components/Icons/FilterIcon";
type PropType = {
  handleTableSearch: (value: string) => void;
  handlePageChange: (page: number, pageSize: number) => void;
  pageSize: number;
  totalDocs: number;
  handleStatus: (status: "active" | "disabled" | "" | "unassigned") => void;
};
function Filters({
  handleTableSearch,
  pageSize,
  totalDocs,
  handlePageChange,
  handleStatus,
}: PropType) {
  const handleSearch = (value: string) => {
    handleTableSearch(value);
  };
  const [filter, setFilter] = useState<{
    active: boolean;
    all: boolean;
    disabled: boolean;
    revoked: boolean;
  }>({
    active: false,
    all: true,
    disabled: false,
    revoked: false,
  });
  const handlePage = (page: number, pageSize: number) => {
    handlePageChange(page, pageSize);
  };
  useEffect(() => {
    handleStatus(
      filter.active
        ? "active"
        : filter.disabled
          ? "disabled"
          : filter.revoked
            ? "unassigned"
            : "",
    );
  }, [filter.active, filter.disabled, filter.revoked, handleStatus]);
  return (
    <div className={s.wrapper}>
      <div className={s.searchInput}>
        <SearchInput
          style={{ width: "100%", height: "100%" }}
          placeholder="search using either phone numbers or user details"
          width={332}
          height={45}
          handleSearch={handleSearch}
        />
      </div>
      <div className={s.filters}>
        <ReusablePopover
          trigger={"hover"}
          content={
            <FiltersPopOverContent filter={filter} setFilter={setFilter} />
          }
        >
          <button className={s.filter}>
            <FilterIcon className={s.filterIcon} />
            <p>Filter</p>
          </button>
        </ReusablePopover>
        <Paginate onChange={handlePage} pageSize={pageSize} total={totalDocs} />
      </div>
    </div>
  );
}

export default Filters;
